<template>
    <div class="ma-4">
        <v-text-field :label="$translate('Name')" v-model="$root.siteconfig.name" @input="delayedSave" color="zoezi-edit-color" />
        <v-select :label="$translate('UI Library')" persistent-placeholder :placeholder="$translate('None (Vue 3 only)')" v-model="$root.siteconfig.uiLibrary" :items="uiLibraries" @change="delayedSave" color="zoezi-edit-color" clearable />
        <v-text-field v-model="$root.siteconfig.domainname" :label="$translate('Domain name')" @input="delayedSave" color="zoezi-edit-color" />
    </div>
</template>

<script>
import {debounce} from 'lodash';

export default {
    name: 'GeneralSettings',
    methods: {
        save() {
            this.$root.saveHomePage();
        },
        delayedSave: debounce(function() { this.save(); }, 1000)
    },

    data: () => ({
        uiLibraries: [
            { text: 'Vuetify 3 - not supported', value: 'vuetify3' },
            { text: 'PrimeVue 4', value: 'primevue4' }
        ]
    })
}
</script>
